import React, { useRef, useEffect, useState } from "react"
import Tooltip from '../Tooltip'
import Notification from '../Notification'

const ZoomPlus = require('../../assets/icons/map/Plus.svg')
const ZoomMinus = require('../../assets/icons/map/Less.svg')
const Location = require('../../assets/icons/map/Location.svg')
const MapOverview = require('../../assets/icons/map/Overview.svg')
const Mapmarker = require('../../assets/icons/map/Mapmarker.svg')
const DEFAULT_ZOOM_LEVEL = 7
const DEFAULT_CENTER_LEVEL = { lat: 43.043619, lng: -76.145119 }
const zoomInTooltip = "Zoom in further to view the lights"

export const MessageNotification = ({ userPos, messageOff }) => {
  return (!messageOff &&
    <Notification className="notification-warning notification-map">
      We cannot determine your position at this location
    </Notification>
  )
}

export default ({ map }) => {
  const OVERVIEW_STREET_LIGHT = 18
  const MIN_ZOOM = 7
  const MAX_ZOOM = 20
  const zoomInCallOut = useRef(null)
  const [userPos, setUserPos] = useState({})
  const [messageOff, setMessageOff] = useState(true)
  const [showMessageBox, setShowMessageBox] = useState(false)

  useEffect(() => {
    const onZoomChange = () => {
      const el = zoomInCallOut.current

      if (map.getZoom() >= OVERVIEW_STREET_LIGHT) {
        el && el.classList.add("-hide-before-after")
      } else {
        el && el.classList.remove("-hide-before-after")
      }
    }

    map.addListener("zoom_changed", onZoomChange)
    return () => {
      map && map.removeListener && map.removeListener("zoom_changed", onZoomChange)
    }

  }, [map, zoomInCallOut])

  useEffect(() => {
    if (navigator.geolocation) {
      var tempPos = {}
      navigator.geolocation.getCurrentPosition((position) => {
        tempPos.lat = position.coords.latitude
        tempPos.lng = position.coords.longitude
        setUserPos(tempPos)
        setMessageOff(true)
      },
      (error) => {
        setUserPos({})
        setMessageOff(false)
      }
      )
    }
  }, [])

  const goToZoomIn = () => {
    if (map.getZoom() < MAX_ZOOM) {
      map.setOptions({ zoom: map.getZoom() + 1 })
    }
  }

  const goToZoomOut = () => {
    if (map.getZoom() > MIN_ZOOM) {
      map.setOptions({ zoom: map.getZoom() - 1 })
    }

  }

  const ShowLocationMessage = async () => {
    setShowMessageBox(true)
    await sleep(5000)
    setShowMessageBox(false)
  }

  const goToLocation = () => {
    if (messageOff && userPos != null && userPos !== undefined) {
      const marker = new window.google.maps.Marker({
        position: { lat: userPos.lat, lng: userPos.lng },
        map: map,
        icon: Mapmarker,
      })
      map.panTo(marker.getPosition())
    } else {
      ShowLocationMessage(true)
    }
  }

  const sleep = async (ms) => {
    return new Promise((resolve, reject) => {
      if (isNaN(ms)) {
        reject(new Error("sleep requires a valid number"))
      } else {
        window.setTimeout(resolve, ms)
      }
    })
  }

  const goToMapView = () => {
    map.setOptions({ zoom: DEFAULT_ZOOM_LEVEL, center: DEFAULT_CENTER_LEVEL })
  }

  return (
    <>
      <div className="map-controller-container" data-test="map-controller-container">
        <div ref={zoomInCallOut} className="tooltip-container -zoom-in-call-out" aria-label={zoomInTooltip} data-tooltip={zoomInTooltip} data-test="map-zoomin">
          <img className="icon-maps" data-test="zoomPlus" src={ZoomPlus} onClick={goToZoomIn} alt="zoom in" />
        </div>

        <div className="icon-location-zoomout" data-test="map-zoomout">
          <Tooltip aria-label={`Map Zoom Out`} data-test="map-zoomout-text" tooltipcontent={<span>Map Zoom Out</span>}>
            <img className="icon-maps" data-test="zoomMinus" src={ZoomMinus} onClick={goToZoomOut} alt="zoom out" />
          </Tooltip>
        </div>

        <div className="icon-location-myloc" data-test="map-showmylocation">
          <Tooltip aria-label={`Show my location`} data-test="location-text" tooltipcontent={<span>Show my location</span>}>
            <img className="icon-maps" data-test="location" src={Location} onClick={goToLocation} alt="show Location"/>
          </Tooltip>
        </div>

        <div className="icon-location-overview" data-test="map-overview">
          <Tooltip aria-label={`Map Overview`} data-test="overview-text" tooltipcontent={<span>Map Overview</span>}>
            <img className="icon-maps" data-test="mapOverview" src={MapOverview} onClick={goToMapView} alt="map overview" />
          </Tooltip>
        </div>
      </div>
      {showMessageBox && <MessageNotification {... { userPos, messageOff: messageOff }} />}
    </>
  )

}